import React from 'react';
import { M_TRACK_LOGO_LIME } from '../../../constants/MTrackConstants';

function Hero() {
  return (
    <div className="mt-hero">
      <div className="mt-row">
        <div className="mt-column mt-hero__info">
          <div className="mt-hero__logo">
            <img src={M_TRACK_LOGO_LIME} alt="M-Track" />
          </div>
          <p className="mt-strapline">
            Don’t miss a beat. Stay on top of the day-to-day with our dashboard.
          </p>
          <p>
            Seamlessly integrate your accounting, payroll, marketing and sales
            all in 1 smart place. Welcome to the future of business.
          </p>
        </div>
        <img
          alt="M-Track preview"
          className="mt-hero__image"
          src="../images/vm/m-track/hero-image@1x.png"
          srcSet="../images/vm/m-track/hero-image@1x.png 1x, ../images/vm/m-track/hero-image@2x.png 2x"
        />
      </div>
    </div>
  );
}

export { Hero };
